import { Overlay } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import { ModalScrollStrategyOptions } from './modal-scroll-strategy-options';

@Injectable({
    providedIn: 'root'
})
export class ModalOverlay extends Overlay {
    override scrollStrategies = inject(ModalScrollStrategyOptions);
}
